import { ElevationProfile } from "../services/terrain/route-elevation-profile";
import { ObstacleSpan } from "../services/terrain/route-obstacle-profile";
import type { aircraftStruct } from "../plugins/opsctrl-foc/class/providers/fppProvider";
import type { navLegStruct } from "../plugins/opsctrl-foc/class/navLogReport";
import { opsMissionTypeEnum, property } from "../plugins/opsctrl-foc/dataStruct";

// briefing flow component - features
// ----------------------------------------------------- //
export interface briefgFlowFlightStruct {
  acft: aircraftStruct;
  flightId: string;
  origin_gui: string;
  flightNumber: string;
  dest_gui: string;
  trackDistAndAlternate: number;
  alternateDist: number;
  _progress: number;
  _statusMsg: string;
  status: briefgFlowFlightStatusEnum;
  flightParameters: briefgFlowFlightParamStruct[];
  annunciators: briefgFlowAnnunciatorStruct[];
  route: briefgFlowRouteStruct[];
  briefingContent: briefgFlowContStruct[];
  elevationProfile?: ElevationProfile | null;
  elevationProfileBase?: ElevationProfile | null;
  obstacleSpans?: ObstacleSpan[];
  /** The navlog legs the card was built from, so a consumer does not read them again. */
  legs?: navLegStruct[];
}
export class briefgFlowFlightParamStruct {
  name: string;
  value: string;
  type: property;
}
export class briefgFlowAnnunciatorStruct {
  desig: string;
  warnType: string;
  type: breifgFlowAnnunWarningTypeEnum;
  opsMissionType: opsMissionTypeEnum;
}
export enum breifgFlowAnnunWarningTypeEnum {
  fuel = 1,
  mAndB = 2,
  perf = 3,
  wx = 4,
  navig = 5,
  notam = 6,
}
export class briefgFlowRouteStruct {
  geoPos?: number[];
  desig: string;
  remark: string;
  trackDist: number;
}
export class briefgFlowContStruct {
  type: briefgFlowContentEnum;
  title: string;
  parameters: any[]; // freedom of implementation :)
  trackDist: number;
}
export enum briefgFlowContentEnum {
  metar = 1,
  doc = 2,
  webcam = 3,
}
export enum briefgFlowFlightStatusEnum {
  planned = 1,
  active = 2,
  archive = 3,
  alert = 4,
}
export class geoQueryResStruct {
  geoPos: number[];
  trackDist: number;
  routeOffsetDist: number;
  feature: any;
}
